import { Link } from '@mui/material';
import { useSelector } from 'react-redux';
import { useThemeContext } from '../../theme/ThemeContext';

const Logo: React.FC = () => {
  const account = useSelector((state: any) => state.accounts.selected);
  const { activeDomainConfig } = useThemeContext();

  let logoURL: string;
  if (account && account.logo) {
    logoURL = account.logo;
  } else {
    logoURL = activeDomainConfig.logo;
  }

  const FALLBACK_LOGO = activeDomainConfig.logo;

  return (
    <Link color="inherit" underline="none">
      <img
        src={logoURL}
        alt={activeDomainConfig.brandName}
        style={{
          width: 200,
          height: 30,
          objectFit: 'contain',
        }}
        onError={(e) => {
          (e.target as HTMLImageElement).src = FALLBACK_LOGO;
        }}
      />
    </Link>
  );
};

export default Logo;
